import { Modal, Select, Form, Spin } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import deburr from 'lodash/deburr';
import { loginMultiUser } from '../../../redux/authentication/actionCreator';
import { AuthFormWrap, SpinerCustomStyle } from '../../../container/profile/authentication/style';
import { Button } from '../../buttons/buttons';
import formHelper from '../../../utility/formHelper';

function CokluUserGirisYap({ girisYapilabilecekKullaniciListesi, onClick }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const girisYap = async () => {
    setLoading(true);
    const values = formHelper.getFormValues(form);
    if (!formHelper.isEmptyFieldVal(values)) {
      const kullanici = girisYapilabilecekKullaniciListesi.find((item) => item.idStr === values.kullanici);
      await dispatch(
        loginMultiUser(kullanici, () => {
          onClick();
          navigate('/admin');
        }),
      );
    }
  };

  return (
    <Modal
      visible
      footer={null}
      onCancel={() => {
        onClick();
      }}
    >
      {loading && (
        <SpinerCustomStyle>
          <Spin />
        </SpinerCustomStyle>
      )}
      <AuthFormWrap>
        <Form form={form} layout="vertical" onFinish={girisYap}>
          <Form.Item
            label={t('girisSayfasi.kullaniciSec')}
            name="kullanici"
            rules={[{ required: true, message: 'Lütfen kullanıcı seçin!' }]}
          >
            <Select
              showSearch
              placeholder={t('girisSayfasi.kullaniciSec')}
              optionFilterProp="children"
              defaultValue=""
              filterOption={(input, option) =>
                deburr(option.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
              }
            >
              <Select.Option value="">{t('select')}</Select.Option>
              {girisYapilabilecekKullaniciListesi.map((item) => (
                <Select.Option key={item.idStr} value={item.idStr}>
                  {item.ad}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Button type="success" htmlType="submit" className="btn-signin mt-0">
            {t('girisSayfasi.girisYap')}
          </Button>
        </Form>
      </AuthFormWrap>
    </Modal>
  );
}

CokluUserGirisYap.propTypes = {
  girisYapilabilecekKullaniciListesi: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CokluUserGirisYap;
